export default __webpack_public_path__ + "static/media/330_business01-it-mobile.cd9f4881.png";